import { Routes } from '@angular/router';
import { authenticationGuard } from './guards/authentication.guard';
import { toolboxMeetingManageGuard } from './guards/toolbox-meeting-manage.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/footer/footer.routes').then((m) => m.routes),
    canActivate: [authenticationGuard],
  },
  {
    path: 'work/:projectId',
    loadComponent: () => import('./pages/work-details/work-details.page').then((m) => m.WorkDetailsPage),
    canActivate: [authenticationGuard],
  },
  {
    path: 'work/:projectId/workers',
    loadComponent: () => import('./pages/work-workers/work-workers.page').then((m) => m.WorkWorkersPage),
    canActivate: [authenticationGuard],
  },
  {
    path: 'work/:projectId/select',
    loadComponent: () =>
      import('./pages/work-details/select-project/select-project.page').then((m) => m.SelectProjectPage),
    canActivate: [authenticationGuard],
  },
  {
    path: 'work/:projectId/select-success',
    loadComponent: () =>
      import('./pages/work-details/select-project-success/select-project-success.page').then(
        (m) => m.SelectProjectSuccessPage,
      ),
    canActivate: [authenticationGuard],
  },
  {
    path: 'styleguide',
    loadComponent: () => import('./pages/styleguide/styleguide.page').then((m) => m.StyleguidePage),
  },
  {
    path: 'onboarding',
    loadComponent: () => import('./pages/onboarding/onboarding.page').then((m) => m.OnboardingPage),
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'yivi-registration',
    loadComponent: () => import('./pages/yivi-registration/yivi-registration.page').then((m) => m.YiviRegistrationPage),
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./pages/forgot-password/forgot-password.page').then((m) => m.ForgotPasswordPage),
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./pages/reset-password/reset-password.page').then((m) => m.ResetPasswordPage),
  },
  {
    // The emailed employment-invitation link (ILOPUMA-633/634). No auth guard: the offer is
    // shown logged-out; the page itself routes through Yivi login before accepting.
    path: 'accept-invitation',
    loadComponent: () => import('./pages/accept-invitation/accept-invitation.page').then((m) => m.AcceptInvitationPage),
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/profile.routes').then((m) => m.profileRoutes),
    canActivate: [authenticationGuard],
  },
  {
    path: 'uma',
    loadChildren: () => import('./pages/uma/uma.routes').then((m) => m.routes),
    canActivate: [authenticationGuard],
  },
  {
    path: 'notifications',
    loadComponent: () => import('./pages/notifications/notifications.page').then((m) => m.NotificationsPage),
    canActivate: [authenticationGuard],
  },
  {
    path: 'work/:projectId/start-work-instruction',
    loadChildren: () => import('./pages/start-work-instruction/start-work-instruction.routes').then((m) => m.routes),
    canActivate: [authenticationGuard],
  },
  {
    path: 'work/:projectId/alerts/new',
    loadComponent: () => import('./pages/alerts/new-alert/new-alert.page').then((m) => m.NewAlertPage),
    canActivate: [authenticationGuard],
  },
  {
    path: 'work/:projectId/alerts/:alertId',
    loadComponent: () => import('./pages/alerts/alert-details/alert-details.page').then((m) => m.AlertDetailsPage),
    canActivate: [authenticationGuard],
  },
  {
    path: 'work/:projectId/alerts/:alertId/edit',
    loadComponent: () => import('./pages/alerts/edit-alert/edit-alert.page').then((m) => m.EditAlertPage),
    canActivate: [authenticationGuard],
  },
  {
    path: 'work/:projectId/organisationDetails',
    loadComponent: () =>
      import('./pages/organisation-details/organisation-details.component').then((m) => m.OrganisationDetailsComponent),
    canActivate: [authenticationGuard],
  },
  {
    path: 'checklist/:checklistId',
    loadComponent: () => import('./pages/checklist/checklist.component').then((m) => m.ChecklistComponent),
    canActivate: [authenticationGuard],
  },
  {
    // Where a person QR opened outside the app lands: the code is a URL, so the phone's own camera
    // can follow it. AppService.handleAppUrlOpen turns it into /verify?payload=..., and the QR screen
    // in the home page's header opens its scan sheet on that payload.
    path: 'verify',
    loadComponent: () => import('./pages/home/home.page').then((m) => m.HomePage),
  },
  {
    path: 'safety-instruction/:safetyInstructionId',
    loadComponent: () =>
      import('./pages/safety-instruction/safety-instruction.page').then((m) => m.SafetyInstructionPage),
  },
  {
    path: 'toolbox/:toolboxId/organisation/:organisationId',
    loadComponent: () => import('./pages/toolbox/toolbox.page').then((m) => m.ToolboxPage),
    canActivate: [authenticationGuard],
  },
  {
    path: 'toolbox/:toolboxId/for-safety-requirements/:projectId',
    loadComponent: () => import('./pages/toolbox/toolbox.page').then((m) => m.ToolboxPage),
    canActivate: [authenticationGuard],
  },
  {
    path: 'toolbox-meeting-add-participant/:meetingId/toolbox/:toolboxId/organisation/:organisationId',
    loadComponent: () =>
      import('./pages/toolbox-meeting-add-participant/toolbox-meeting-add-participant.page').then(
        (m) => m.ToolboxMeetingAddParticipantPage,
      ),
    canActivate: [authenticationGuard, toolboxMeetingManageGuard],
  },
  {
    path: 'toolbox-meeting-add-participant/:meetingId/organisation/:organisationId',
    loadComponent: () =>
      import('./pages/toolbox-meeting-add-participant/toolbox-meeting-add-participant.page').then(
        (m) => m.ToolboxMeetingAddParticipantPage,
      ),
    canActivate: [authenticationGuard, toolboxMeetingManageGuard],
  },
  {
    path: 'toolbox-meeting/:meetingId/toolbox/:toolboxId/organisation/:organisationId',
    loadComponent: () => import('./pages/toolbox-meeting/toolbox-meeting.page').then((m) => m.ToolboxMeetingPage),
    canActivate: [authenticationGuard],
  },
  {
    path: 'toolbox-meeting/:meetingId/organisation/:organisationId',
    loadComponent: () => import('./pages/toolbox-meeting/toolbox-meeting.page').then((m) => m.ToolboxMeetingPage),
    canActivate: [authenticationGuard],
  },
  {
    path: 'join-toolbox-meeting',
    loadComponent: () =>
      import('./pages/join-toolbox-meeting/join-toolbox-meeting.page').then((m) => m.JoinToolboxMeetingPage),
    canActivate: [authenticationGuard],
  },
];
